import { Directives } from '../schema/directives';
const isDefinitionObjectHasDirective = (def, directiveName) => {
  if (!def) {
    return false;
  }
  for (const node of def) {
    const {
      operation: type,
      directives
    } = node;
    if (type === 'query' || type === 'mutation') {
      return directives && directives.some(directive => directive.name.value === directiveName);
    }
  }
};
const isQueryContainDirective = (opt, directiveName) => {
  const globalDef = opt.query && opt.query.definitions;
  const childDef = opt.query &&
  // @ts-ignore (TS7053)
  opt.query[opt.operationName] &&
  // @ts-ignore (TS7053)
  opt.query[opt.operationName].definitions;
  return !!(isDefinitionObjectHasDirective(globalDef, directiveName) || isDefinitionObjectHasDirective(childDef, directiveName));
};

/**
 * Util function for determining whether an operation is a "custom query" that
 * is resolved by custom resolvers within the app, or queries intended for the
 * directory service.
 * It does this based on the presence/absence of the @custom directive.
 */
export const isCustomQuery = opt => {
  return isQueryContainDirective(opt, Directives.CUSTOM);
};